import { ArrowDown, ArrowUp } from "lucide-react";

import { cn } from "@/utils/ui";

import { SortState } from "@components/DataTables/hooks/use-sorting";

type SortableColumnHeaderProps = {
  column: string;
  label: string;
  sortState: SortState;
  onSort: (column: string) => void;
  className?: string;
};

export const SortableColumnHeader = ({
  column,
  label,
  sortState,
  onSort,
  className,
}: SortableColumnHeaderProps) => (
  <div
    className={cn(
      "flex shrink-0 text-sm font-medium text-foreground-muted",
      className
    )}
  >
    <button
      className={cn(
        "flex items-center gap-1 truncate hover:text-primary-600",
        sortState.column === column && "font-semibold"
      )}
      onClick={() => onSort(column)}
      type="button"
    >
      {label}
      {sortState.column === column &&
        (sortState.direction === "asc" ? (
          <ArrowUp className="size-4" />
        ) : (
          <ArrowDown className="size-4" />
        ))}
    </button>
  </div>
);
